function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_718_367)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.4987 13.8833L18.019 2.40299C16.354 0.738553 13.6459 0.738553 11.9809 2.40299L0.501148 13.8833C0.140568 14.2439 0.140568 14.8283 0.501148 15.1889C0.861152 15.5495 1.44616 15.5495 1.80616 15.1889L2.53828 14.4568V26.1915C2.53828 27.6572 3.72647 28.8454 5.19216 28.8454H9.80759C10.1262 28.8454 10.3845 28.5871 10.3845 28.2684V19.7299C10.3845 18.1368 11.676 16.8452 13.2692 16.8452H16.7307C18.3239 16.8452 19.6154 18.1368 19.6154 19.7299V28.2684C19.6154 28.5871 19.8737 28.8454 20.1923 28.8454H24.8077C26.2734 28.8454 27.4616 27.6572 27.4616 26.1915V14.4568L28.1937 15.1889C28.3737 15.3689 28.6103 15.4595 28.8462 15.4595C29.0822 15.4595 29.3187 15.3689 29.4987 15.1889C29.8593 14.8283 29.8593 14.2439 29.4987 13.8833Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_718_367"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.5385,
  height: 29.5385,
  fill: "white",
  transform: "translate(0.230713 0.230774)"
})));

function SvgAccomodationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodationIcon);
export default __webpack_public_path__ + "static/media/accomodationIcon.978dbe96.svg";
export { ForwardRef as ReactComponent };